import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import {
	GET_UNIVERSITIES_STRUCTURES,
	GET_FACULTIES_STRUCTURES,
	GET_SPECIALITIES_STRUCTURES,
	EDIT_UNIVERSITY_STRUCTURE,
	ADD_UNIVERSITY_STRUCTURE,
	DELETE_UNIVERSITY_STRUCTURE,
	APPROVED_UNIVERSITY_STRUCTURE,
	EDIT_FACULTY_STRUCTURE,
	ADD_FACULTY_STRUCTURE,
	DELETE_FACULTY_STRUCTURE,
	APPROVED_FACULTY_STRUCTURE,
	EDIT_SPECIALITY_STRUCTURE,
	ADD_SPECIALITY_STRUCTURE,
	DELETE_SPECIALITY_STRUCTURE,
	APPROVED_SPECIALITY_STRUCTURE
} from '../constants/Structure';
import {
	getUniversitiesStructuresSuccess,
	getUniversitiesStructuresError,
	getFactultiesStructuresSuccess,
	getFacultiesStructuresError,
	getSpecialitiesStructuresSuccess,
	getSpecialitiesStructuresError,
	editUniversityStructureSuccess,
	editUniversityStructureError,
	addUniversityStructureSuccess,
	addUniversityStructureError,
	deleteUniversityStructureSuccess,
	deleteUniversityStructureError,
	approvedUniversityStructureSuccess,
	approvedUniversityStructureError,
	editFacultyStructureSuccess,
	editFacultyStructureError,
	addFacultyStructureSuccess,
	addFacultyStructureError,
	deleteFacultyStructureSuccess,
	deleteFacultyStructureError,
	approvedFacultyStructureSuccess,
	approvedFacultyStructureError,
	editSpecialityStructureSuccess,
	editSpecialityStructureError,
	addSpecialityStructureSuccess,
	addSpecialityStructureError,
	deleteSpecialityStructureSuccess,
	deleteSpecialityStructureError,
	approvedSpecialityStructureSuccess,
	approvedSpecialityStructureError
} from "../actions/Structure";

import {
	getUniversitiesService,
	getFacultiesService,
	getSpecialitiesService,
	editUniversityStructureService,
	addUniversityStructureService,
	deleteUniversityStructureService,
	approvedUniversityStructureService,
	editFacultyStructureService,
	addFacultyStructureService,
	deleteFacultyStructureService,
	approvedFacultyStructureService,
	editSpecialityStructureService,
	addSpecialityStructureService,
	deleteSpecialityStructureService,
	approvedSpecialityStructureService
} from 'redux/services/Structure';

export function* getUniversitiesStructuresSaga() {
	yield takeEvery(GET_UNIVERSITIES_STRUCTURES, function* ({ payload }) {
		try {
			const data = yield call(getUniversitiesService);
			if (data.message) {
				yield put(getUniversitiesStructuresError(data.message));
			} else {
				yield put(getUniversitiesStructuresSuccess(data));
			}
		} catch (err) {
			yield put(getUniversitiesStructuresError(err));
		}
	});
}

export function* getFacultiesStructuresSaga() {
	yield takeEvery(GET_FACULTIES_STRUCTURES, function* ({ payload }) {
		try {
			const data = yield call(getFacultiesService);
			if (data.message) {
				yield put(getFacultiesStructuresError(data.message));
			} else {
				yield put(getFactultiesStructuresSuccess(data));
			}
		} catch (err) {
			yield put(getFacultiesStructuresError(err));
		}
	});
}

export function* getSpecialitiesStructuresSaga() {
	yield takeEvery(GET_SPECIALITIES_STRUCTURES, function* ({ payload }) {
		try {
			const data = yield call(getSpecialitiesService);
			if (data.message) {
				yield put(getSpecialitiesStructuresError(data.message));
			} else {
				yield put(getSpecialitiesStructuresSuccess(data));
			}
		} catch (err) {
			yield put(getSpecialitiesStructuresError(err));
		}
	});
}

export function* editUniversityStructureSaga() {
	yield takeEvery(EDIT_UNIVERSITY_STRUCTURE, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(editUniversityStructureService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(editUniversityStructureError(result.message));
			} else {
				yield call(cb, { message: 'University saved', type: 'success' });
				yield put(editUniversityStructureSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(editUniversityStructureError(err));
		}
	});
}

export function* addUniversityStructureSaga() {
	yield takeEvery(ADD_UNIVERSITY_STRUCTURE, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(addUniversityStructureService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(addUniversityStructureError(result.message));
			} else {
				yield call(cb, { message: 'University saved', type: 'success' });
				yield put(addUniversityStructureSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(addUniversityStructureError(err));
		}
	});
}

export function* deleteUniversityStructureSaga() {
	yield takeEvery(DELETE_UNIVERSITY_STRUCTURE, function* ({ payload }) {
		const { id, cb } = payload;
		try {
			const result = yield call(deleteUniversityStructureService, id);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(deleteUniversityStructureError(result.message));
			} else {
				yield call(cb, { message: 'University deleted', type: 'success' });
				yield put(deleteUniversityStructureSuccess());
			}
		} catch (err) {
			yield call(cb, { message: 'Error !', type: 'error' });
			yield put(deleteUniversityStructureError(err));
		}
	});
}

export function* approvedUniversityStructureSaga() {
	yield takeEvery(APPROVED_UNIVERSITY_STRUCTURE, function* ({ payload }) {
		const { id, approved, cb } = payload;
		try {
			const result = yield call(approvedUniversityStructureService, id, approved);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(approvedUniversityStructureError(result.message));
			} else {
				yield call(cb, { message: 'University approved field updated', type: 'success' });
				yield put(approvedUniversityStructureSuccess());
			}
		} catch (err) {
			yield call(cb, { message: 'Error !', type: 'error' });
			yield put(approvedUniversityStructureError(err));
		}
	});
}

export function* editFacultyStructureSaga() {
	yield takeEvery(EDIT_FACULTY_STRUCTURE, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(editFacultyStructureService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(editFacultyStructureError(result.message));
			} else {
				yield call(cb, { message: 'Faculty saved', type: 'success' });
				yield put(editFacultyStructureSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(editFacultyStructureError(err));
		}
	});
}

export function* addFacultyStructureSaga() {
	yield takeEvery(ADD_FACULTY_STRUCTURE, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(addFacultyStructureService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(addFacultyStructureError(result.message));
			} else {
				yield call(cb, { message: 'Faculty saved', type: 'success' });
				yield put(addFacultyStructureSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(addFacultyStructureError(err));
		}
	});
}

export function* deleteFacultyStructureSaga() {
	yield takeEvery(DELETE_FACULTY_STRUCTURE, function* ({ payload }) {
		const { id, cb } = payload;
		try {
			const result = yield call(deleteFacultyStructureService, id);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(deleteFacultyStructureError(result.message));
			} else {
				yield call(cb, { message: 'Faculty deleted', type: 'success' });
				yield put(deleteFacultyStructureSuccess());
			}
		} catch (err) {
			yield call(cb, { message: 'Error !', type: 'error' });
			yield put(deleteFacultyStructureError(err));
		}
	});
}

export function* approvedFacultyStructureSaga() {
	yield takeEvery(APPROVED_FACULTY_STRUCTURE, function* ({ payload }) {
		const { id, approved, cb } = payload;
		try {
			const result = yield call(approvedFacultyStructureService, id, approved);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(approvedFacultyStructureError(result.message));
			} else {
				yield call(cb, { message: 'Faculty approved field updated', type: 'success' });
				yield put(approvedFacultyStructureSuccess());
			}
		} catch (err) {
			yield call(cb, { message: 'Error !', type: 'error' });
			yield put(approvedFacultyStructureError(err));
		}
	});
}

export function* editSpecialityStructureSaga() {
	yield takeEvery(EDIT_SPECIALITY_STRUCTURE, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(editSpecialityStructureService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(editSpecialityStructureError(result.message));
			} else {
				yield call(cb, { message: 'Speciality saved', type: 'success' });
				yield put(editSpecialityStructureSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(editSpecialityStructureError(err));
		}
	});
}

export function* addSpecialityStructureSaga() {
	yield takeEvery(ADD_SPECIALITY_STRUCTURE, function* ({ payload }) {
		const { data, cb } = payload;
		try {
			const result = yield call(addSpecialityStructureService, data);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(addSpecialityStructureError(result.message));
			} else {
				yield call(cb, { message: 'Speciality saved', type: 'success' });
				yield put(addSpecialityStructureSuccess());
			}
		} catch (err) {
			yield call(cb, { message: err, type: 'error' });
			yield put(addSpecialityStructureError(err));
		}
	});
}

export function* deleteSpecialityStructureSaga() {
	yield takeEvery(DELETE_SPECIALITY_STRUCTURE, function* ({ payload }) {
		const { id, cb } = payload;
		try {
			const result = yield call(deleteSpecialityStructureService, id);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(deleteSpecialityStructureError(result.message));
			} else {
				yield call(cb, { message: 'Speciality deleted', type: 'success' });
				yield put(deleteSpecialityStructureSuccess());
			}
		} catch (err) {
			yield call(cb, { message: 'Error !', type: 'error' });
			yield put(deleteSpecialityStructureError(err));
		}
	});
}

export function* approvedSpecialityStructureSaga() {
	yield takeEvery(APPROVED_SPECIALITY_STRUCTURE, function* ({ payload }) {
		const { id, approved, cb } = payload;
		try {
			const result = yield call(approvedSpecialityStructureService, id, approved);
			if (result.message) {
				yield call(cb, { message: result.message, type: 'error' });
				yield put(approvedSpecialityStructureError(result.message));
			} else {
				yield call(cb, { message: 'Speciality approved field updated', type: 'success' });
				yield put(approvedSpecialityStructureSuccess());
			}
		} catch (err) {
			yield call(cb, { message: 'Error !', type: 'error' });
			yield put(approvedSpecialityStructureError(err));
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(getUniversitiesStructuresSaga),
		fork(getFacultiesStructuresSaga),
		fork(getSpecialitiesStructuresSaga),
		fork(editUniversityStructureSaga),
		fork(addUniversityStructureSaga),
		fork(deleteUniversityStructureSaga),
		fork(approvedUniversityStructureSaga),
		fork(editFacultyStructureSaga),
		fork(addFacultyStructureSaga),
		fork(deleteFacultyStructureSaga),
		fork(approvedFacultyStructureSaga),
		fork(editSpecialityStructureSaga),
		fork(addSpecialityStructureSaga),
		fork(deleteSpecialityStructureSaga),
		fork(approvedSpecialityStructureSaga),
	]);
}
